import {EdgeProps} from 'reactflow';

import {
  DataFlowEdgeForValidation,
  ProcessFlowchartForValidation,
  ProcessFlowchartValidationError,
  getHighestValidationSeverity,
} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import {ProcessFlowchartEdgeType} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';
import {EdgeStatus} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeConstants';

export function getEdgeStatus(props: EdgeProps): EdgeStatus | undefined {
  const errors: Array<ProcessFlowchartValidationError> | undefined = props.data?.validationErrors;
  if (errors == null || errors.length === 0) {
    return undefined;
  }
  return getHighestValidationSeverity(errors);
}

export function hasMatchingControlFlowEdge(
  edge: DataFlowEdgeForValidation,
  flowchart: ProcessFlowchartForValidation
): boolean {
  return flowchart.edges.some(
    (e) =>
      e.type === ProcessFlowchartEdgeType.CONTROL_FLOW && e.target === edge.target && e.source === edge.source
  );
}
